const BaseRoutes = {
	WhatWeDo: '/what-we-do',
	WhoWeAre: '/who-we-are',
	OurServices: '/our-services',
} as const;

const WhatWeDo = {
	Landing: BaseRoutes.WhatWeDo,
	Sameday: `${BaseRoutes.WhatWeDo}/sameday`,
	BulkOrders: `${BaseRoutes.WhatWeDo}/bulk-orders`,
	SmallOrders: `${BaseRoutes.WhatWeDo}/small-orders`,
	BYOPrinting: `${BaseRoutes.WhatWeDo}/byo-merchandise`,
	Labelling: `${BaseRoutes.WhatWeDo}/labelling`,
	DesignTool: `${BaseRoutes.WhatWeDo}/design-tool`,
	PrintOnDemand: `${BaseRoutes.WhatWeDo}/print-on-demand`,
	DropShipping: {
		Landing: `${BaseRoutes.WhatWeDo}/partners`,
		HowItWorks: `${BaseRoutes.WhatWeDo}/partners/how-it-works`,
		GetStarted: `${BaseRoutes.WhatWeDo}/partners/get-started`,
	},
} as const;

const WhoWeAre = {
	Landing: BaseRoutes.WhoWeAre,
	OurStories: `/our-stories`,
	OurPlanet: `/our-planet`,
	OurValues: `/our-values`,
	OurTeam: `${BaseRoutes.WhoWeAre}/our-team`,
	OurPartners: `${BaseRoutes.WhoWeAre}/our-partners`,
	OurCustomers: `${BaseRoutes.WhoWeAre}/our-customers`,
	OurCommunity: `${BaseRoutes.WhoWeAre}/our-community`,
	OurImpact: `${BaseRoutes.WhoWeAre}/our-impact`,
} as const;

const OurServices = {
	Landing: BaseRoutes.OurServices,
	DigitalPrinting: `${BaseRoutes.OurServices}/digital-printing`,
	Embroidery: `${BaseRoutes.OurServices}/embroidery`,
	ScreenPrinting: `${BaseRoutes.OurServices}/screen-printing`,
	DFTPrinting: `${BaseRoutes.OurServices}/direct-to-film`,
	// Compare: `${BaseRoutes.OurServices}/compare`,
};

export default {
	Home: '/',
	JournalListing: '/journal',
	JournalPage: (slug: string) => `/journal/${slug}`,
	PolicyListing: '/policies',
	PolicyPage: (slug: string) => `/policies/${slug}`,
	HelpListing: '/help',
	HelpCategoryPage: (slug: string, article?: string) => `/help/${slug}${article ? `#${article}` : ''}`,
	Contact: '/contact',
	Calculator: (code: string) => `?calculate=${code}`,
	//SEO Pages
	Page: (id: string) => `/page/${id}`,
	Search: '/search',
	WhatWeDo,
	WhoWeAre,
	OurServices,
};
